var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTuvalu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_982)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.0001 19.9999C40.0001 31.0455 31.0457 39.9999 20.0001 39.9999C8.95444 39.9999 6.10352e-05 31.0455 6.10352e-05 19.9999C6.10352e-05 20.0046 20.0001 0.00206543 20.0001 -0.00012207C31.0457 -0.00012207 40.0001 8.95425 40.0001 19.9999Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.56535 20.0001H16.3108L10.4349 13.0436L9.56535 15.6522V20.0001Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 16.3109L13.0436 9.56531H20L20.0001 16.3109Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9466 19.9999H20.0001C20.0001 19.982 20.0001 19.9645 20.0001 19.9464C19.9823 19.9643 19.9645 19.9821 19.9466 19.9999Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 10.4346C20.0001 6.9155 20.0001 4.60957 20.0001 -0.00012207H19.9968C8.95256 0.00175293 6.10352e-05 8.95527 6.10352e-05 19.9999H10.4349V14.124L16.3108 19.9999H19.9467C19.9645 19.9821 19.9823 19.9643 20.0002 19.9464C20.0002 18.5989 20.0002 17.3967 20.0002 16.3107L14.1241 10.4346H20.0001Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1183 2.60876C6.99022 4.38994 4.38975 6.99041 2.60858 10.1185V20.0001H7.826V7.82634V7.82619H19.9999C19.9999 6.18064 19.9999 4.61298 19.9999 2.60876H10.1183Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 17.5406L12.894 10.4349H10.4346V10.4351L19.9997 20.0001H19.9999C19.9999 20.0001 19.9999 18.3042 19.9999 17.5406V17.5406Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8286 33.0436L22.2603 34.3722H23.6572L22.5272 35.1933L22.9589 36.5218L21.8286 35.7008L20.6985 36.5218L21.1302 35.1933L20 34.3722H21.3969L21.8286 33.0436Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9539 24.3479L33.3856 25.6765H34.7825L33.6524 26.4977L34.0842 27.8262L32.9539 27.0052L31.8238 27.8262L32.2556 26.4977L31.1252 25.6765H32.5222L32.9539 24.3479Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7417 11.3044L36.1734 12.633H37.5704L36.4403 13.4541L36.8719 14.7826L35.7417 13.9616L34.6116 14.7826L35.0433 13.4541L33.9131 12.633H35.31L35.7417 11.3044Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4321 20.8696L36.8638 22.1983H38.2607L37.1306 23.0194L37.5623 24.3479L36.4321 23.5269L35.302 24.3479L35.7338 23.0194L34.6034 22.1983H36.0004L36.4321 20.8696Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8316 29.9186L25.0766 30.5529L26.0643 29.5652L25.8459 30.9448L27.0905 31.579L25.7106 31.7976L25.4921 33.1774L24.858 31.9326L23.4782 32.1513L24.4659 31.1635L23.8316 29.9186Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8316 24.7014L25.0766 25.3356L26.0643 24.3479L25.8459 25.7276L27.0905 26.3617L25.7106 26.5803L25.4921 27.9601L24.858 26.7154L23.4782 26.934L24.4659 25.9463L23.8316 24.7014Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1795 28.0457L29.4244 28.68L30.4121 27.6923L30.1937 29.0719L31.4383 29.7061L30.0584 29.9247L29.8399 31.3045L29.2059 30.0596L27.826 30.2784L28.8138 29.2906L28.1795 28.0457Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1795 16.8752L29.4244 17.5095L30.4121 16.5217L30.1937 17.9014L31.4383 18.5356L30.0584 18.7541L29.8399 20.1339L29.2059 18.8892L27.826 19.1078L28.8138 18.1201L28.1795 16.8752Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3933 16.7415L33.6382 17.3757L34.6259 16.3879L34.4074 17.7676L35.6521 18.4018L34.2723 18.6204L34.0538 20.0001L33.4197 18.7554L32.0399 18.974L33.0276 17.9863L32.3933 16.7415Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_982"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTuvalu);
export default __webpack_public_path__ + "static/media/tuvalu.160b475868bdc9c001ce775b8186ece7.svg";
export { ForwardRef as ReactComponent };